import React, { useEffect } from "react";
import DataGrid, {
  Column,
  Pager,
  Paging,
  FilterRow,
  HeaderFilter,
  GroupPanel,
  Summary,
  TotalItem,
  Selection,
  GroupItem,
  SortByGroupSummaryInfo,
  Export,
} from "devextreme-react/data-grid";
import { getNavigatorLanguage } from "../../utils";
import { locale } from "devextreme/localization";
import Spinner from "../common/Spinner";

const PayableReport = ({ reportStore, isLoading }) => {
  useEffect(() => {
    locale(getNavigatorLanguage());
  }, []);

  const onToolbarPreparing = (e) => {
    let toolbarItems = e.toolbarOptions.items;
    toolbarItems.forEach(function (item) {
      item.showText = true;

      if (item.name === "searchPanel" || item.name === "columnChooserButton") {
        item.location = "after";
      } else {
        item.location = "before";
      }
    });
  };

  const format = {
    precision: 2,
    type: "fixedPoint",
  };

  return (
    <div style={{ marginTop: "20px", marginBottom: "20px" }}>
      {reportStore && !isLoading && (
        <DataGrid
          id="gridContainer"
          keyExpr="id"
          dataSource={reportStore}
          showBorders={true}
          hoverStateEnabled={true}
          focusedRowEnabled={true}
          defaultFocusedRowIndex={0}
          cellHintEnabled={true}
          remoteOperations={false}
          showRowLines={true}
          allowColumnResizing={true}
          allowColumnReordering={true}
          showColumnLines={true}
          rowAlternationEnabled={true}
          wordWrapEnabled={true}
          onToolbarPreparing={onToolbarPreparing}
        >
          <GroupPanel visible={true} />
          <HeaderFilter visible={false} />

          <FilterRow visible={false} applyFilter="auto" />
          <Selection
            mode="multiple"
            selectAllMode="allPages"
            // showCheckBoxesMode="always"
          />
          <Export
            enabled={true}
            excelWrapTextEnabled={true}
            fileName="Tax_Payable_Report"
            allowExportSelectedData={true}
          />

          <Paging defaultPageSize={50} />
          <Pager
            showNavigationButtons={true}
            showPageSizeSelector={true}
            allowedPageSizes={[50, 100, 200]}
            showInfo={true}
          />
          <Column dataField="taxRateName" caption="Tax" groupIndex={0} />
          <Column dataField="locationName" caption="Location" />
          <Column dataField="totalNet" caption="Net Total" format={format} />
          <Column dataField="totalTax" caption="Tax Total" format={format} />
          <Column
            dataField="totalWithTax"
            caption="Total With Tax"
            format={format}
          />

          <Summary recalculateWhileEditing={true} texts={{ sum: "{0}" }}>
            {/* <GroupItem
              column="locationName"
              summaryType="count"
              displayFormat="{0} location(s)"
            /> */}
            <GroupItem
              column="totalNet"
              summaryType="sum"
              showInGroupFooter={true}
              alignByColumn={true}
              valueFormat={format}
            />
            <GroupItem
              column="totalTax"
              summaryType="sum"
              showInGroupFooter={true}
              alignByColumn={true}
              valueFormat={format}
            />
            <GroupItem
              column="totalWithTax"
              summaryType="sum"
              // displayFormat="Total: {0}"
              alignByColumn={true}
              showInGroupFooter={true}
              valueFormat={format}
            />
            <TotalItem
              column="totalTax"
              summaryType="sum"
              displayFormat="Total: {0}"
              valueFormat={format}
            />
            <TotalItem
              column="totalWithTax"
              summaryType="sum"
              displayFormat="Total: {0}"
              valueFormat={format}
            />
            <TotalItem
              column="netTotal"
              summaryType="sum"
              displayFormat="Total: {0}"
              valueFormat={format}
            />
          </Summary>
          <SortByGroupSummaryInfo summaryItem="count" />
        </DataGrid>
      )}
      {isLoading && <Spinner />}
    </div>
  );
};

export default PayableReport;
